import { useEffect, useRef } from 'react';

/**
 * A pinned AMI id only exists in one account and region, so drop the pin when
 * the credential or region changes.
 *
 * Compared only against a scope that was seen with a loaded form. The edit form
 * arrives a render or two after mount; comparing against the empty first render
 * made a freshly opened edit look like a region change and wiped the saved pin.
 */
export default function usePinScopeReset(form, setField) {
    const scope = form ? `${form.credentialId || ''}|${form.regionId || ''}` : null;
    const seen = useRef(null);
    const pinned = form ? form.serverImageId : '';

    useEffect(() => {
        if (scope === null) return;
        if (seen.current === null) {
            seen.current = scope;
            return;
        }
        if (seen.current === scope) return;
        seen.current = scope;
        if (pinned) setField('serverImageId', '');
    }, [scope, pinned, setField]);
}
